import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { API, BACKEND_URL } from "../config";
import { formatHUF, getDisplayPrice, parseSizes } from "../lib/format";
import Footer from "./components/Footer";
import { useCart } from "../contexts/AppContext";
import { useFanClub } from "../contexts/AppContext";

export default function StorePage() {
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedSizes, setSelectedSizes] = useState({});
  const { addToCart } = useCart();
  const { member, tiers } = useFanClub();

  useEffect(() => { axios.get(`${API}/products`).then(res => setProducts(res.data)).catch(console.error); }, []);

  const categories = [
    { key: 'all', label: 'Összes' },
    { key: 'Pólók', label: 'Pólók' },
    { key: 'Pulóverek', label: 'Pulóverek'},
    { key: 'Bögrék', label: 'Bögrék'}
  ];
  const filteredProducts = selectedCategory === 'all' ? products : products.filter(p => p.category === selectedCategory);

  const handleAddToCart = (product) => {
    const sizes = parseSizes(product.sizes);
    if (sizes.length && !selectedSizes[product.id]) { toast.error('Kérlek válassz méretet!'); return; }
    addToCart({ product_id: product.id, product_name: product.name, price: product.price, image: product.image, size: selectedSizes[product.id] || null, item_type: 'product' });
  };

  return (
    <>
    <div className="min-h-screen pt-24 sm:pt-32 pb-32 px-4 sm:px-6 md:px-12 lg:px-24" data-testid="store-page">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 sm:mb-16 animate-fade-in">
          <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-primary mb-2 sm:mb-4">Hivatalos termékek</p>
          <h1 className="text-3xl sm:text-5xl md:text-7xl font-bold font-['Syne'] tracking-tighter">Bolt</h1>
        </div>

        <div className="flex flex-wrap gap-2 sm:gap-3 mb-6 sm:mb-12">
          {categories.map((cat) => (
            <Button key={cat.key} variant={selectedCategory === cat.key ? 'default' : 'outline'} onClick={() => setSelectedCategory(cat.key)}
              className={`rounded-full text-xs sm:text-sm px-3 sm:px-4 py-1 h-auto ${selectedCategory === cat.key ? 'bg-primary hover:bg-primary/90' : 'border-white/20 hover:bg-white/10'}`}>
              {cat.label}
            </Button>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6 lg:gap-8">
          {filteredProducts.map((product, index) => (
            <div key={product.id} className="group animate-fade-in" style={{ animationDelay: `${index * 0.1}s` }}>
              <Link to={`/bolt/${product.slug || product.id}`} className="block">
                <div className="relative rounded-lg sm:rounded-xl overflow-hidden mb-2 sm:mb-4 bg-card">
                  <div className="aspect-square"><img src={product.image?.startsWith?.("http") ? product.image : `${BACKEND_URL}/storage/${product.image}`} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" /></div>
                  {!product.in_stock && <div className="absolute inset-0 bg-black/70 flex items-center justify-center"><Badge className="text-xs sm:text-lg">Elfogyott</Badge></div>}
                </div>
                <div>
                  <Badge variant="outline" className="mb-1 capitalize border-white/20 text-[9px] sm:text-xs">{product.category}</Badge>
                  <h3 className="font-bold font-['Syne'] text-sm sm:text-lg mb-0.5 group-hover:text-primary transition-colors">{product.name}</h3>
                </div>
              </Link>
              <div>
                {parseSizes(product.sizes).length > 0 && (
                  <div className="flex flex-wrap gap-1 sm:gap-2 mb-2">
                    {parseSizes(product.sizes).map((size) => (
                      <button key={size} onClick={() => setSelectedSizes(prev => ({ ...prev, [product.id]: size }))}
                        className={`w-7 h-7 sm:w-10 sm:h-10 rounded-md text-[10px] sm:text-sm font-medium transition-colors ${selectedSizes[product.id] === size ? 'bg-primary text-white' : 'bg-white/5 hover:bg-white/10'}`}>{size}</button>
                    ))}
                  </div>
                )}
                <div className="flex items-center justify-between gap-2">
                  <span className="text-base sm:text-xl font-bold text-primary">{formatHUF(getDisplayPrice(product.price, member, tiers))}</span>
                  <Button onClick={() => handleAddToCart(product)} disabled={!product.in_stock} className="rounded-full bg-primary hover:bg-primary/90 text-[10px] sm:text-sm px-2 sm:px-4 h-7 sm:h-10">
                    <span className="hidden sm:inline">Kosárba</span><span className="sm:hidden">+</span>
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
}
